import { useTranslation } from 'react-i18next';

import { ChurchSearch } from '@/components/church-search';
import { GivePageShell } from '@/components/give-page-shell';
import { PoweredByFooter } from '@/components/powered-by-footer';

export const HomePage = () => {
  const { t } = useTranslation();

  return (
    <GivePageShell footer={<PoweredByFooter />}>
      <div className="give-card give-card--centered stack">
        <header className="give-card-header">
          <h1 className="give-card-title">{t('home.title')}</h1>
          <p className="give-card-lead">{t('home.subtitle')}</p>
        </header>
        <ChurchSearch />
      </div>
    </GivePageShell>
  );
};
